
import React from "react";
import { Grid, IconButton } from "@mui/material"
import { iconos } from "../../../data";




export const FBAFuncion = ({ funcion, icono }) => {


    return (

        <Grid sx={{position:'fixed', bottom:20, right:30}}>

            <IconButton sx={{ color: '#fff', backgroundColor: 'primary.main',
                ':hover': {backgroundColor: 'primary.main', opacity: 0.5}, }}
                onClick={ funcion }
            >
                { React.cloneElement(iconos[icono], {style:{fontSize:30} }) }
            </IconButton>
        </Grid>

    )
}
